import ERC20 from '../abi/ERC20.json';
import { ethers, BigNumber } from 'ethers';
import { getAddress } from './get-address'; 

export const getTokenBalance = async (_token) => { 
  let success = false;
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum); 
    if(provider){
      const signer = provider.getSigner();
      const address = await signer.getAddress();
       if (  address) {
        const signer = provider.getSigner();
        const tokenContract = new ethers.Contract(_token, ERC20.abi, signer);
         const decimals = await tokenContract.decimals(); 
        const response = await tokenContract.balanceOf(
          address  
        );
        const balance = parseFloat(response.toString()) / 10 ** decimals;
        success = true;
        return {
          success,
          balance  
        };
      } else {
        return { success: false, message: 'Wrong Network!' };
      }
    }else {
      return { success: false, message: 'Wrong Connection!' };
    }
   
  } catch (e) {
    return { success: false, message: e.message };
  }
};
